import React from "react";
import Footer from "../footer";
import Navbar from "../navbar/Navbar";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";

function About() {
  return (
    <>
      <Navbar />
      <section className="about">
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-center">
              <div className="contact-info">
                <h3>Email</h3>
                <a href="mailto:avitdesai6145@gmail.com" className="text-decoration-none">
                  avitdesai6145@gmail.com
                </a>
              </div>
              <div className="contact-info">
                <h3>Phone</h3>
                <p>Just Contact Me In Contact Section</p>
              </div>
            </div>
            <div className="col-md-6">
              <iframe
                title="Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14689.611048990055!2d72.55729799999999!3d23.008979500000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8504875176a1%3A0x7aa1193d3ab36f85!2sPaldi%2C%20Ahmedabad%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1702582096647!5m2!1sen!2sin"
                width="100%"
                height="300"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
          <div className="row text-center p-4">
            <h1>
              You are at the perfect place <br />
              I'm Avit, a programmer, <br /> Tech Enthusiast <br /> Passionate Engineer
              <br />
              Want To Connect..
            </h1>
            <Nav.Link>
              <Link to="/Contact" className="nav-link">
                <button className="btn btn-danger">Let's Connect</button>
              </Link>
            </Nav.Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default About;
